export enum LineupVariant {
  MAIN = 'main',
  SECTION = 'section',
  CONDENSED = 'condensed',
  PLAYLIST = 'playlist'
}
